import {
  isObjectSplits,
  getPhotos,
  checkJKCategory,
  checkBusinessCenterCategory,
  getJKId,
  getBusinessCenterId,
  getJKHouseId,
} from '../../../../../utils';
import { getIsCommercial } from '../../../../../utils/category/getIsCommercial';
import { IAppState } from '../../../../types';
import {
  selectDynamicPricingParameters,
  selectIsArchived,
  selectIsByHomeowner,
  selectLocationsFromAddress,
  selectOfferCategory,
  selectOfferCoordinatesWithFallback,
  selectOfferId,
} from '../../../../../selectors/offer';
import { selectActivePlacingType, selectPlacingMoneySource } from '../../../../../selectors/publishTerms';
import { IPublishTermsRequest } from '../../../../../repositories/billing-tariffs/v1/publish-terms';
import { EPlacingType } from '../../../../reducers';
import { selectConfigValue } from '../../../../../selectors/config';

export const getParameters = (state: IAppState): IPublishTermsRequest => {
  const { offer } = state;
  const { bargainTerms, totalArea, areaParts } = offer;

  const id = selectOfferId(state);
  const category = selectOfferCategory(state);
  const photos = getPhotos(offer);
  const isMultiListing = isObjectSplits(offer);
  const locationPath = selectLocationsFromAddress(state).reverse();
  const { lat, lng } = selectOfferCoordinatesWithFallback(state);
  const isJKCategory = checkJKCategory(offer);
  const isBusinessCenterCategory = checkBusinessCenterCategory(offer);
  const newObjectId = getJKId(offer);
  const newObjectHouseId = getJKHouseId(offer);
  const businessShoppingCenterId = getBusinessCenterId(offer);
  const isFromArchive = selectIsArchived(state);
  const moneySource = selectPlacingMoneySource(state);
  const extraData = selectDynamicPricingParameters(state);
  const isByHomeowner = selectIsByHomeowner(state);

  const result: IPublishTermsRequest = {
    ...(isJKCategory && { newObjectId, newObjectHouseId }),
    ...(isBusinessCenterCategory && { businessShoppingCenterId }),
    ...(id && { id }),
    ...(category && { category }),
    photosCount: photos.length,
    locationPath,
    latitude: lat,
    longitude: lng,
    isMultiListing,
    isFromArchive,
    uiType: 'desktop',
    moneySource,
    extraData,
    isByHomeowner,
  };

  const isCommercial = !!category && getIsCommercial(category);
  const activePlacingType = selectActivePlacingType(state);
  /**
   * @todo Удалить строку с RS
   * @description Данный функционал появился в задаче CD-155300, будет удалён в задаче CD-155303
   */
  const diffPricesPackageEnabled = selectConfigValue('diffPricesPackageEnabled', state);

  const isPackageOnUi = activePlacingType ? activePlacingType === EPlacingType.package : null;

  if (isCommercial) {
    Object.assign<IPublishTermsRequest, Partial<IPublishTermsRequest>>(result, {
      price: bargainTerms.price,
      currency: bargainTerms.currency,
      priceType: bargainTerms.priceType,
      paymentPeriod: bargainTerms.paymentPeriod,
      totalArea,
      multiListingSlotsCount: areaParts?.length ?? null,
      /**
       * @todo Удалить условие с RS
       * @description Данный функционал появился в задаче CD-155300, будет удалён в задаче CD-155303
       */
      ...(diffPricesPackageEnabled && { isPackageOnUi }),
    });
  }

  return result;
};
